<template>
  <mv-page>
    <v-flex xs1 class="hidden-md-and-down" style="position:fixed; top: 70px">
      <h2 class="font-weight-light">Заявления</h2>
    </v-flex>
    <mv-med-row>
      <v-layout row wrap>
        <v-flex xs12>
          <v-subheader class="pl-0 px-0">
            <v-spacer></v-spacer>
            <v-btn text outline color="primary" class="ma-0" @click="openAddDialog()">
              Новое заявление
            </v-btn>
          </v-subheader>
        </v-flex>
        <v-flex xs12>
          <v-expansion-panel>
            <v-expansion-panel-content
              v-for="item in statements"
              :key="item.statementid"
            >
              <template v-slot:header>
                <table cellspacing="0" cellpadding="0">
                  <tr>
                    <td width="50%" class="pa-1">{{ item.title }}</td>
                    <td>
                      <div v-if="item.status==='Отправлено'">
                        <v-icon color="blue">send</v-icon>
                      </div>
                      <div v-if="item.status==='Принято к исполнению'">
                        <v-icon color="orange">update</v-icon>
                      </div>
                      <div v-if="item.status==='Исполнено'">
                        <v-icon color="green">task_alt</v-icon>
                      </div>
                      <div v-if="item.status==='Отклонено'">
                        <v-icon color="red">close</v-icon>
                      </div>
                    </td>
                    <td width="30%" class="pa-1">{{ item.status }}</td>
                    <td  class="pa-1">{{ item.cts.split('T')[0] }}</td>
                  </tr>
                </table>
              </template>
              <v-card>
                <v-card-text>
                  <span v-html="item.content"></span>
                </v-card-text>
              </v-card>
            </v-expansion-panel-content>
          </v-expansion-panel>
        </v-flex>
      </v-layout>
      <v-layout row wrap>
        <v-dialog
          v-model="addDialog"
          scrollable
          persistent
          :fullscreen="$vuetify.breakpoint.xs"
          :overlay="false"
          max-width="600px"
          transition="dialog-transition"
        >
        <v-card>
          <v-toolbar flat>
            Новое заявление
            <v-spacer></v-spacer>
            <v-btn icon small dark color="red" class="mr-3" @click="closeAddDialog()">
              <v-icon>close</v-icon>
            </v-btn>
          </v-toolbar>
          <v-card-text>
            <v-form
              ref="form"
              v-model="isFormValid">
              <!-- общие для всех типов поля -->
              <v-select
                v-model="curStatement.statementType"
                :items="statementTypes"
                label="Тип заявления"
                dense
                hide-details
                required
              ></v-select>
              <v-text-field
                v-model="curStatement.email"
                :rules="emailRules"
                name="email"
                label="Адрес электронной почты"
                type="email"
                dense
                hide-actions
                required
              ></v-text-field>
              <v-text-field
                v-model="curStatement.phone"
                label="Контактный номер телефона (10 цифр)"
                :rules="phoneRules"
                prefix="+7"
                mask="(###)-###-####"
                placeholder="(xxx)-xxx-xxxx"
                dense
                required
              ></v-text-field>
              <v-text-field
                v-model="curStatement.ownerFullname"
                :rules="commonRules"
                name="ownerFullname"
                label="ФИО родителя (полностью)"
                required
              ></v-text-field>
              <v-text-field
                v-model="curStatement.studentFullname"
                :rules="commonRules"
                name="studentFullname"
                label="ФИО учащегося"
                required
                readonly
              ></v-text-field>
              <v-text-field
                name="fromCard"
                label="Карта списания"
                v-model="curStatement.fromCard"
                :rules="commonRules"
                required
                readonly
              ></v-text-field>
              <v-text-field
                name="school"
                label="Учебное заведение"
                v-model="curStatement.schoolname"
                :rules="commonRules"
                required
              ></v-text-field>
              <v-text-field
                name="positionname"
                label="Класс"
                v-model="curStatement.positionname"
                :rules="commonRules"
                required
              ></v-text-field>
              <v-text-field
                v-model="curStatement.amount"
                :rules="[ checkAmount ]"
                :label="`Сумма списания (доступно ${curStatement.availableAmount} руб.)`"
                name="amount"
                type="number"
              ></v-text-field>
              <!-- поля для возврата по безналу -->
              <v-select
                v-if="curStatement.statementType === 'cashlessReturn'"
                :items="returnReasons"
                v-model="curStatement.returnReason"
                label="Причина возврата"
                dense
                required
              ></v-select>
              <span v-if="curStatement.statementType === 'cashlessReturn'">Внимание! При некорректном заполнении банковских реквизитов платеж будет отклонён банком. </span>
              <v-checkbox v-if="curStatement.statementType === 'cashlessReturn'" label="Уведомление мной прочитано" v-model="bankNoty" required></v-checkbox>
              <v-text-field
                v-if="curStatement.statementType === 'cashlessReturn'"
                v-model="curStatement.recipientLastname"
                :rules="commonRules"
                name="recipientLastname"
                label="Фамилия получателя денежных средств"
                :disabled="!bankNoty"
                required
              ></v-text-field>
              <v-text-field
                v-if="curStatement.statementType === 'cashlessReturn'"
                v-model="curStatement.recipientFirstname"
                :rules="commonRules"
                name="recipientFirstname"
                label="Имя получателя денежных средств"
                :disabled="!bankNoty"
                required
              ></v-text-field>
              <v-text-field
                v-if="curStatement.statementType === 'cashlessReturn'"
                v-model="curStatement.recipientPatronymic"
                name="recipientPatronymic"
                label="Отчество получателя денежных средств"
                :disabled="!bankNoty"
                required
              ></v-text-field>
              <v-text-field
                v-if="curStatement.statementType === 'cashlessReturn'"
                v-model="curStatement.accountNumber"
                :rules="accountNumberRules"
                name="accountNumber"
                label="№ банковского счета"
                :disabled="!bankNoty"
                required
              ></v-text-field>
              <v-text-field
                v-if="curStatement.statementType === 'cashlessReturn'"
                v-model="curStatement.bankName"
                :rules="commonRules"
                name="bankName"
                label="Наименование банка"
                :disabled="!bankNoty"
                required
              ></v-text-field>
              <v-text-field
                v-if="curStatement.statementType === 'cashlessReturn'"
                v-model="curStatement.bik"
                :rules="bikRules"
                name="bik"
                label="БИК банка"
                :disabled="!bankNoty"
                required
              ></v-text-field>
              <!-- поля для перевода с питания на питание -->
              <v-text-field
                v-if="curStatement.statementType === 'transferToCard' || curStatement.statementType === 'delayedTransfer'"
                v-model="curStatement.toCard"
                :rules="toCardRules"
                name="cardNumber"
                label="Номер карты зачисления"
                required
              ></v-text-field>
              <v-text-field
                v-if="curStatement.statementType === 'transferToCard' || curStatement.statementType === 'delayedTransfer'"
                v-model="curStatement.recipientFullname"
                :rules="commonRules"
                name="recipientFullname"
                label="ФИО получателя"
                required
              ></v-text-field>
              <b><i>
                Обработка вашего заявления осуществляется в течение 10 рабочих дней.
              </i></b><br>
              <b><i v-if="curStatement.statementType === 'delayedTransfer'">
                Денежные средства будут зачислены на счет карты транспорта на
                следующий день после исполнения заявления в момент оплаты проезда.
              </i></b>
              <v-checkbox
                label="С условиями предоставления данной услуги ознакомлен и согласен"
                v-model="agreement"
                hide-details
                required
                ></v-checkbox>
            </v-form>
          </v-card-text>
          <v-card-actions>
            <v-btn flat color="primary" @click="closeAddDialog()">Отмена</v-btn>
            <v-spacer></v-spacer>
            <v-btn flat color="primary" :disabled="!isFormValid || !agreement || !curStatement.statementType" type="submit" @click="saveStatement()">Отправить</v-btn>
          </v-card-actions>
          <span v-html="newOne.content"></span>
          <v-card-text>
          </v-card-text>
          <v-card>
          <span v-html="newOne.content"></span>
        </v-card>
        </v-card>
        </v-dialog>
      </v-layout>
    </mv-med-row>
  </mv-page>
</template>

<script>
const moment = require('moment')
export default {
  name: 'statements',
  data: () => ({
    isFormValid: false,
    statements: [],
    addDialog: false,
    agreement: false,
    bankNoty: false,
    curStatement: {
      statementType: ''
    },
    submitBtn: true,
    returnReasons: [
      { value: 'errorPayment', text: 'ошибочным пополнением счета электронной карты' },
      { value: 'endSchool', text: 'окончанием образовательной организации' },
      { value: 'moving', text: 'переездом в другой город' },
      { value: 'death', text: 'смертью' },
      { value: 'other', text: 'иное (ненадобностью)' }
    ],
    statementTypes: [
      { value: 'delayedTransfer', text: 'Перевод с питания на транспорт (отложенное пополнение)' },
      { value: 'cashlessReturn', text: 'Возврат со школьного питания безнал' },
      { value: 'transferToCard', text: 'Перевод с питания на питание' }
    ],
    commonRules: [
        v => !!v || 'Поле не может быть пустым',
      ],
    emailRules: [
        v => !!v || 'Поле e-mail не может быть пустым',
        v => /\S+@\S+\.\S+/.test(v) || 'E-mail должен быть корретный'
      ],
    phoneRules: [
      v => !!v || 'Поле телефон не может быть пустым',
      v => /(\d{10})/.test(v) || 'Номер телефона должен содержать 10 цифр'
    ],
    passportSeriesRules: [
      v => !!v || 'Поле серия паспорта не может быть пустым',
      v => /(\d{4})/.test(v) || 'Серия паспорта должна содержать 4 цифры'
    ],
    passportNumberRules: [
      v => !!v || 'Поле номер паспорта не может быть пустым',
      v => /(\d{6})/.test(v) || 'Номер паспорта должен содержать 6 цифр'
    ],
    passportIssuedDateRules: [
      v => !!v || 'Поле дата выдачи паспорта не может быть пустым',
      v => /(0?[1-9]|[12][0-9]|3[01])\.(0?[1-9]|1[012])\.((19|20)\d\d)/.test(v) || 'Дата выдачи паспорта должна быть введена в формате dd.mm.yyyy'
    ],
    accountNumberRules: [
      v => !!v || 'Поле номер банковского счета не может быть пустым',
      v => /^[\d]{20}$/.test(v) || 'Номер счета должен быть корректный (20 цифр)'
    ],
    bikRules: [
      v => !!v || 'Поле БИК не может быть пустым',
      v => /^[\d]{9}$/.test(v) || 'БИК должен быть корректный (9 цифр)'
    ],
    innRules: [
      v => !!v || 'Поле ИНН не может быть пустым',
      v => /^[\d]{12}$/.test(v) || 'ИНН должен быть корректный (12 цифр)'
    ],
    kppRules: [
      v => !!v || 'Поле КПП не может быть пустым',
      v => /^[\d]{9}$/.test(v) || 'КПП должен быть корректный (9 цифр)'
    ],
    toCardRules: [
      v => !!v || 'Поле номер карты зачисления не может быть пустым',
      v => /^[\d]{5,9}$/.test(v) || 'Номер карты должен быть корректный (от 5 до 9 цифр)'
    ],
    newOne: { content: '' }
  }),
  computed: {
    profile () {
      return this.$store.state.profile
    }
  },
  methods: {
    async fetch () {
      const { statements } = await this.$store.dispatch('sioRequest', {
        topic: 'fetch-statements',
        pl: {}
      })
      this.statements = statements
    },
    closeAddDialog () {
      this.addDialog = false
      this.curStatement = {}
      this.newOne = {}
      this.isFormValid = false
    },
    acceptNumber() {
      let x = this.curStatement.phone.replace(/\D/g, '').match(/(\d{0,3})(\d{0,3})(\d{0,4})/)
      let y = !x[2] ? x[1] : '(' + x[1] + ') ' + x[2] + (x[3] ? '-' + x[3] : '')
      this.curStatement.phone = y.slice(0, 11)
    },
    async saveStatement () {
      this.newOne.statementtype = this.curStatement.statementType
      this.newOne.fullname = this.curStatement.studentFullname
      this.newOne.amount = parseInt(this.curStatement.amount*100)
      if (this.curStatement.ownerFullname) {
        this.curStatement.ownerFullname = this.curStatement.ownerFullname.split(' ').map(x => x.charAt(0).toUpperCase() + x.slice(1)).join(' ')
      }
      if (this.curStatement.statementType === 'cashlessReturn' && this.curStatement.recipientLastname && this.curStatement.recipientFirstname) {
        this.curStatement.recipientFullname = `${this.curStatement.recipientLastname} ${this.curStatement.recipientFirstname} ${this.curStatement.recipientPatronymic || ' '}`
      }
      if (this.curStatement.recipientFullname) {
        this.curStatement.recipientFullname = this.curStatement.recipientFullname.split(' ').map(x => x.charAt(0).toUpperCase() + x.slice(1)).join(' ')
      }
      this.newOne.status = 'Отправлено'
      this.newOne.content = `
      <div style="font-size:11pt;font-family:'Times New Roman';line-height:1.2">
        <table cellspacing="0" cellpadding="0">
          <tr>
            <td width="55%"></td>
            <td>
              <div align="left">
                <span>В МБУ "ЦДС ГПТ"</span><br>
                <span>от ${this.curStatement.ownerFullname}</span><br>
                <span>E-mail: ${this.curStatement.email}</span><br>
                <span>Телефон: +7${this.curStatement.phone}</span><br><br>
              </div>
            </td>
          </tr>
        </table>
        <div align="center">
          <strong>заявление.</strong><br><br>
        </div>
      `
      if (this.curStatement.statementType === 'delayedTransfer' || this.curStatement.statementType === 'transferToCard') {
        this.newOne.title = this.statementTypes.find(x => x.value === this.curStatement.statementType).text
        this.newOne.content += `
          <div>
            <span>Прошу перевести денежные средства в сумме <u>${this.curStatement.amount} руб.</u><br><br>
            <u>&#9633; со счета транспорта на счет транспорта</u><br>
            <u>&#9633; со счета транспорта на счет питания</u><br>
            <u>${this.curStatement.statementType === 'delayedTransfer' ? `&#9745;` : `&#9633;`} со счета питания на счет транспорта</u><br>
            <u>${this.curStatement.statementType === 'transferToCard' ? `&#9745;` : `&#9633;`} со счета питания на счет питания</u><br>
            <i>(нужное отметить)</i><br><br>
            с <u>&#9633; неперсональной / &#9745; персональной</u> электронной карты<br>
            <i>(нужное отметить)</i><br><br>
            серия ____ номер <u>${this.curStatement.fromCard}</u><br><br>
            <u>${this.curStatement.fromCard}, ${this.curStatement.studentFullname}, ${this.curStatement.schoolname}, ${this.curStatement.positionname}</u><br>
            <i>(указать фамилию имя отчество владельца карты, если карта персональная)</i><br><br>
            на <u>&#9633; неперсональную / ${this.curStatement.statementType === 'transferToCard' ? `&#9745;` : `&#9633;`} персональную</u> электронную карту<br>
            <i>(нужное отметить)</i><br><br>
            серия ____ номер <u>${this.curStatement.toCard}</u><br><br>
            <u>${this.curStatement.recipientFullname}</u><br>
            <i>(указать фамилию имя отчество владельца карты, если карта персональная)</i><br><br>
            <span>С условиями предоставления данной услуги ознакомлен(а) и соглас(ен/на)</span>
            <br><br><br>
          </div>
        `
      }
      else if (this.curStatement.statementType === 'cashlessReturn') {
        this.newOne.title = 'Безналичный возврат со счета школьного питания'
        this.newOne.content += `
          <div>
            <span>Прошу вернуть денежные средства c <u>&#9633; неперсональной / &#9745; персональной</u><br><br>
            электронной карты серия ____ номер <u>${this.curStatement.fromCard}</u><br><br>
            <u>${this.curStatement.studentFullname}, ${this.curStatement.schoolname}, ${this.curStatement.positionname}</u><br>
            <i>(указать фамилию имя отчество владельца карты, номер образовательной организации, класс)</i><br><br>
            <u>&#9633; со счета транспорта / &#9745; со счета питания</u><br>
            <i>(нужное отметить)</i><br><br>
            <u>&#9745; на расчетный счет (реквизиты прилагаю) / &#9633; наличными</u> в связи с</span><br><br>
          `
        for (let reason of this.returnReasons) {
          this.newOne.content += `<u>${this.curStatement.returnReason === reason.value ? `&#9745` : `&#9633`}; ${reason.text}</u><br>`
        }
        this.newOne.content += `
            <br><br>
            <p>
              Реквизиты для перечисления:<br>
              ФИО: ${this.curStatement.recipientFullname};<br>
              № расчетного счета: ${this.curStatement.accountNumber};<br>
              Наименование банка: ${this.curStatement.bankName};<br>
              БИК банка: ${this.curStatement.bik}.<br>
            </p>
            <br>
          </div>
        `
      }
      this.newOne.content += `
        <table width="100%" cellspacing="0" cellpadding="0">
          <tr>
            <td width="50%"><span>Дата: <u>${moment().format('DD-MM-YYYY')}</u></span></td>
            <td align="right">
              <span>${this.curStatement.ownerFullname.split(' ')[0]}</span><br>
            </td>
          </tr>
        </table>
      </div>
      `
      await this.$store.dispatch('sioRequest', {
        topic: 'statements-add',
        pl: this.newOne
      })
      this.closeAddDialog()
      this.fetch()
    },
    async openAddDialog () {
      const { balance } = await this.$store.dispatch('sioRequest', {
        topic: 'balance',
        pl: {}
      })
      this.curStatement.studentFullname = this.profile.fullname
      this.curStatement.fromCard = this.profile.cardid
      this.curStatement.availableAmount = parseFloat(balance/100).toFixed(2)
      this.addDialog = true
    },
    checkAmount (value) {
      if (parseFloat(value) > 0 && parseFloat(value) <= parseFloat(this.curStatement.availableAmount)) {
        return true
      } else
      if (parseFloat(value) > parseFloat(this.curStatement.availableAmount)) {
        this.disabled = true
        return `На балансе недостаточно средств`
      } else {
        this.disabled = true
        return `Некорректная сумма`
      }
    }
  },
  watch: {
    async profile (val) {
      if (val) await this.fetch()
    }
  },
  async mounted () {
    if (this.profile) await this.fetch()
  },
}
</script>

<style lang="css">
.cursor-pointer {
  cursor: pointer;
}
.inline-block {
  display: inline-block;
}
.trs {
  padding: 6px 16px 0 16px;
  font-size: 14px;
}
/* инверсия по горизонтали */
.column-reverse { display: flex; flex-direction: column-reverse; }
</style>
